import { render, staticRenderFns } from "./ModalDefault.vue?vue&type=template&id=03cf8268&"
import script from "./ModalDefault.vue?vue&type=script&lang=js&"
export * from "./ModalDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports